/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React from 'react';
import { Icon } from '@alifd/next';
import styles from '../index.module.scss';

import TagRadio from './Nodes/TagRadio';
import TagCheckbox from './Nodes/TagCheckbox';
import TagProvince from './Nodes/TagProvince';
import TagSlider from './Nodes/TagSlider';
import TagSection from './Nodes/TagSection';
import TagSku from './Nodes/TagSku';
import TagCategories from './Nodes/TagCategories';
import TagCrowd from './Nodes/TagCrowd';
import TagTime from './Nodes/TagTime';

/**
 * 根据后端返回的type确定不同类型的标签展示，1.单选 2.多选枚举 3.级联多选 4.整数值 5.数值区间 6.时间区间 7.商品种类 8.人群包类型 9.自定义
 * @param activeTagList-点击左侧标签统计出的所有选中标签
 * @param changeActiveTagValue-对标签选框进行了编辑，传到父组件去修改值
 * @param changeActiveList-点击每个取消图标，删除一个选中标签
 */

// 这个是需要的所有组件，通过标签的valueType判断用哪个组件
const arr = [TagRadio, TagCheckbox, TagProvince, TagSlider, TagSection, TagTime, TagCategories, TagCrowd, TagSku];

const TagMapping = ({
  activeTagList = [], changeActiveTagValue = (contIndex, index, subIndex, newData) => {
  }, changeActiveList = (contItem, contIndex, item, subItem, index, subIndex) => {
  },
}) => {
  return (
    <>
      {
        activeTagList.map((contItem, contIndex) => {
          return (
            <div key={`contItem_${contIndex}`}>
              <div className={`${styles['tag-title']}`}>
                {/* 大分类的title,只展示一次 */}
                {contItem?.crowdLabels?.length >= 1 && <span>{contItem.labelDescription}</span>}
              </div>
              <section className={`${styles['tag-content']}`}>
                {
                    contItem.crowdLabels.map((item, index) => {
                      return (
                        <div key={`item_${index}`}>
                          {/* 二级分类title,只展示一次 */}
                          {item.crowdLabels.length >= 1 && <span>{item.labelDescription}</span>}
                          {
                              item.crowdLabels.map((subItem, subIndex) => {
                                let Content = null;
                                Content = arr[subItem.valueType - 1];
                                // if (subItem.valueType != 3) {
                                //   Content = arr[subItem.valueType - 1];
                                // } else {
                                //   Content = arr[subItem.valueType - 1][Number(subItem.value[1].type) - 1]; // 这个是取接口形式的组件的固定方式。后端返回[{interface: "/api/crowdlabel/brandlist"}, {type: "5"}]
                                // }
                                return (
                                  <div key={`subItem_${subIndex}`}>
                                    <div key={subItem.id} className={`${styles.mb10}`}>
                                      <section
                                        className={`${styles['tag-name']}`}
                                        style={{ position: 'relative' }}
                                      >
                                        {subItem.labelDescription}
                                        <Icon
                                          onClick={(event) => {
                                            changeActiveList(contItem, contIndex, item, index, subItem, subIndex);
                                          }}
                                          type="close"
                                          size="xs"
                                          style={{
                                            cursor: 'pointer',
                                            position: 'absolute',
                                            top: '10px',
                                            right: '15px',
                                          }}
                                        />
                                      </section>
                                      <div className={`${styles['editTag-content']}`}>
                                        <Content
                                          tagItem={subItem}
                                          changeData={(newData) => changeActiveTagValue(contIndex, index, subIndex, newData)}
                                        />
                                        {/* {
                                    (!subItem.selectedValue && !subItem.selectSecondVal || (subItem.valueType === 7 && (String(subItem.selectedValue).split('_').length < 2) || String(subItem.selectedValue).split('_').some(item => item === ''))) && <div style={{color: '#ff3333', lineHeight: '25px'}}>注意: 此标签选值不可为空</div> // 此条数据的选中值为空进行提示 selectedValue-普通标签的存值 selectSecondVal-省市标签的城市值 split的是区间值，通过'_'拼接，会导致可能不填其中一个，也会通过前面两个校验
                                  } */}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            }
                        </div>
                      );
                    })}
              </section>
            </div>
          );
        })}
    </>
  );
};
export default TagMapping;
